<form [formGroup]="form" class="flex-col gap-6">
  <div class="flex-row gap-6 lg-flex-col">
    <mat-form-field appearance="outline" class="section-form-field w-100" floatLabel="always">
      <mat-label>{{ 'generic.title' | translate }}</mat-label>
      <input type="text" formControlName="title" matInput>
    </mat-form-field>
    <mat-form-field appearance="outline" class="section-form-field w-100" floatLabel="always">
      <mat-label>{{ 'generic.subtitle' | translate }}</mat-label>
      <input type="text" formControlName="subtitle" matInput>
    </mat-form-field>
  </div>
  <div formArrayName="source" class="sources">
    @for (control of sourceFormArray.controls; track control; let index = $index) {
      <div class="source-container">
        <mat-form-field appearance="outline" class="section-form-field w-100" floatLabel="always">
          <mat-label>{{ 'activity.section.sources.source.label' | translate }}</mat-label>
          <input type="text" [formControlName]="index" matInput>
          @if (!form.disabled) {
            <button type="button" matSuffix mat-icon-button aria-label="Remove" (click)="sourceFormArray.removeAt(index);">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
    }
  </div>
</form>
